import { getContactsConfiguration } from './contactsConfigurationClient';
import { getResourceToken } from './fileResourceTokenClient';
import { Utils } from 'ecrion-components';

function getContactsForm() {
  return getContactsConfiguration().then(contactConfig => {
    const workspace = contactConfig.Form && contactConfig.Form.Workspace;
    const filePath = contactConfig.Form && contactConfig.Form.FilePath;
    return Utils.request({
      method: 'GET',
      url: `${
        process.env.REACT_APP_WEBSITE_URL
      }/backend/content?workspace=${workspace}&path=${encodeURIComponent(
        filePath
      )}`,
    }).then(res => {
      return new window.DOMParser().parseFromString(res, 'text/xml');
    });
  });
}

function downloadFile(workspace, path, publicAccessToken = null) {
  return getResourceToken(workspace, path, publicAccessToken).then(
    resourceToken => {
      window.open(
        `${
          process.env.REACT_APP_WEBSITE_URL
        }/backend/content?resourceToken=${encodeURIComponent(
          resourceToken
        )}&workspace=${workspace}&path=${path}`,
        '_self'
      );
    }
  );
}

export { getContactsForm, downloadFile };
